import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    payloadKey: { type: String, default: "book_ids" }
  }

  connect() {
    // Only enable drag-to-sort on desktop (md breakpoint and up)
    this.mediaQuery = window.matchMedia("(min-width: 768px)")
    this.handleMediaChange = this.handleMediaChange.bind(this)
    this.mediaQuery.addEventListener("change", this.handleMediaChange)
    this.handleMediaChange()
  }

  handleMediaChange() {
    if (this.mediaQuery.matches) {
      // Desktop: enable sorting
      if (!this.sortable) {
        this.sortable = Sortable.create(this.element, {
          animation: 150,
          ghostClass: "opacity-50",
          // When the user holds Alt/Option mid-drag, they're using the
          // mark-as-duplicate flow (book-drag-drop). Cancel sortable's
          // reorder so the two systems don't both fire on the same drop.
          onMove: (_evt, originalEvent) => {
            if (originalEvent && originalEvent.altKey) return false
          },
          onStart: this.onStart.bind(this),
          onEnd: this.onEnd.bind(this)
        })
      }
    } else {
      // Mobile: disable sorting
      if (this.sortable) {
        this.sortable.destroy()
        this.sortable = null
      }
    }
  }

  disconnect() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener("change", this.handleMediaChange)
    }
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onStart() {
    // Snapshot order at drag start so we can skip the save in onEnd when
    // nothing actually changed (e.g. an Alt-drag that was cancelled by
    // onMove so SortableJS never reordered anything).
    this._startOrder = this._currentOrder()
  }

  async onEnd(event) {
    const ids = this._currentOrder()
    // If the order is identical to the snapshot (Alt-drag cancelled, or the
    // user dropped the card back in its original slot), skip the network
    // round-trip.
    if (this._startOrder && ids.join(",") === this._startOrder.join(",")) return

    try {
      await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ [this.payloadKeyValue]: ids })
      })
    } catch (error) {
      console.error("Failed to save order:", error)
    }
  }

  _currentOrder() {
    return Array.from(this.element.children).map(c => c.dataset.sortableId)
  }
}
